import styled from '@emotion/styled';
import { TextInput } from '@workday/canvas-kit-react/text-input';
import { WcpStyles } from '@workday/wcp-tokens';
import React, { Ref } from 'react';

const StyledTextInput = styled(TextInput)({
  color: WcpStyles.color.text.default,
  backgroundColor: WcpStyles.color.bg.default,
  borderColor: `${WcpStyles.color.border.divider} !important`,
  '::placeholder': {
    color: WcpStyles.color.text.hint,
  },
  ':hover': {
    borderColor: `${WcpStyles.color.border.input.strong} !important`,
  },
  ':disabled': {
    backgroundColor: WcpStyles.color.bg.alt.softer,
    borderColor: WcpStyles.color.border.input.disabled,
  },
});

export const ThemedTextInput = React.forwardRef(
  ({ ...props }: React.ComponentProps<typeof TextInput>, ref: Ref<HTMLInputElement>) => {
    return <StyledTextInput {...props} ref={ref} />;
  }
);
ThemedTextInput.displayName = 'ThemedTextInput';
